/**
 * Returns the passed attributes object and type string wrapped in a data object
 * To be used when generating the data payload for 'resume', 'pause', 'cancel' and 'update' requests to Shop Subscriptions API
 *
 * @param attributes - The attributes data object for the request (type is request-specific)
 * @param type - A string indicating the type of request being made
 */
export function formatDataProperties(attributes, type) {
    return {
        data: { attributes, type }
    };
}
//# sourceMappingURL=utils.js.map